import { Model as BaseModel } from 'vue-api-query';
import _ from 'lodash';

export default class Model extends BaseModel {
    baseURL () {
        return process.env.VUE_APP_API_HOST;
    }

    request (config) {
        return this.$http.request(config);
    }

    constructor (...attributes) {
        attributes.length ? super(...attributes) : super();

        let original = attributes[0];

        if(typeof original !== 'undefined') {
            this._original = original;
            this.original_keys = Object.keys(original);
        }
    }

    get isDirty () {
        if (typeof this._original !== 'undefined') {
            return ! _.isEqual(this._original, _.pick(this, this._original_keys));
        }

        return false;
    }

    reset () {
        Object.assign(this, this._original);
    }

    parameterNames () {
        return Object.assign({},
            super.parameterNames(),
            {
                page: 'page[number]',
                limit: 'page[size]',
            }
        );
    }

    applyMutations(model) {
        Object.keys(model.mutations || {}).forEach(propKey => {
            if (! model[propKey]) {
                return;
            }

            const ModelForKey = model.mutations[propKey];

            if (Array.isArray(model[propKey])) {
                model[propKey].forEach((item, i) => {
                    const modelData = model[propKey][i];

                    model[propKey][i] = new ModelForKey(modelData);

                    this.applyMutations(model[propKey][i]);
                });
            } else {
                const modelData = model[propKey];

                model[propKey] = new ModelForKey(modelData);

                this.applyMutations(model[propKey]);
            }
        });
    }

    async save() {
        return await super.save().then(model => {
            this.applyMutations(model);

            return model;
        });
    }

    async $find(id) {
        return await super.$find(id).then(model => {
            this.applyMutations(model);

            return model;
        });
    }

    async $get() {
        return await super.$get().then(models => {
            models.forEach(model => {
                this.applyMutations(model);
            });

            return models;
        });
    }

    async get() {
        return await super.get().then(response => {
            let models = response.data;

            models.forEach(model => {
                this.applyMutations(model);
            });

            return response;
        });
    }
}
